import { isEmpty } from "lodash";
import { AccountModel, AccountType } from "../types/account";

class ActiveAccount {
	account: AccountModel | null;
	accountType: AccountType;
	isAccountOwner: boolean;
	accountName?: string;

	constructor(
		account: AccountModel,
		accountType: AccountType,
		isAccountOwner: boolean,
		accountName?: string
	) {
		this.accountType = account.type;
		this.account = account ?? null;
		this.isAccountOwner = isAccountOwner;

		if (accountName) {
			this.accountName = accountName;
		} else if (accountType === AccountType.COMPANY) {
			this.accountName = this.account?.name;
		}
	}

	get accountId(): string {
		return this.account!.id;
	}

	get countryCode(): string {
		return !this.account?.countryCode || isEmpty(this.account.countryCode) ? "NO" : this.account.countryCode;
	}
}

export default ActiveAccount;
